/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { AutoTestStepBaseInputAsJSON } from './AutoTestStepBaseInputAsJSON';
import { JunitTestExtra } from './JunitTestExtra';
const JunitTestInputAsJSONParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(JunitTestExtra, AutoTestStepBaseInputAsJSON);
export class JunitTestInputAsJSON extends AutoTestStepBaseInputAsJSON {
    static decode(input) {
        return JunitTestInputAsJSONParser.decode(input).map(res => new JunitTestInputAsJSON(res));
    }
    static unsafeDecode(input) {
        return JunitTestInputAsJSON.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return JunitTestInputAsJSONParser.encode(data);
    }
    static schema() {
        return JunitTestInputAsJSONParser.schema();
    }
}
